import { render, staticRenderFns } from "./EtiquetaEnvio.vue?vue&type=template&id=50b77da0&"
import script from "./EtiquetaEnvio.vue?vue&type=script&lang=js&"
export * from "./EtiquetaEnvio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports